import Modal from 'react-modal';
import { useDispatch } from 'react-redux';

import { deleteService, loadProvider } from 'actions/provider';
import ModalContent from 'atoms/modal-content';

export default function DeleteService({
  isOpen,
  openModal,
  closeServiceModal,
  serviceId,
}) {
  const dispatch = useDispatch();

  const onDelete = async () => {
    const deletedService = await dispatch(deleteService(serviceId));
    if (deletedService.success) {
      dispatch(loadProvider());
      openModal(false);
      closeServiceModal();
    }
  };
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={() => openModal(false)}
      shouldCloseOnOverlayClick
      className="edit-info-modal"
    >
      <ModalContent
        title="Delete service?"
        primaryButton="Delete"
        secondaryButton="Cancel"
        primaryButtonAction={onDelete}
        secondaryButtonAction={() => openModal(false)}
        onClose={() => openModal(false)}
      >
        <p>
          Deleting this service will remove it from your service list, and will
          no longer be viewable on PawCare.
        </p>
      </ModalContent>
    </Modal>
  );
}
